import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import type { Epic } from '../../../index.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'
import { addMessage } from '../../../Slice/Application/ApplicationSlice.js'
import { errorMessage } from '../../../../Model/Message/IMessage.js'
import { currentPoolItem } from '../../../Selector/Order/CurrentOrderState.js'
import { describeAttachRefusal } from './attachRefusal.js'

export const AttachReverseFileEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.attachReverseFileRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const { orderId, poolId, sampleId, reverseFileId, absorbSampleId } = action.payload
      /* read at dispatch, not when the dialog opened: an upload may have finished long after */
      const version = currentPoolItem(state[orderSlice.name].samplePools, sampleId)?.version ?? ''
      return OrderRepository.attachReverseFile({ orderId, poolId, sampleId, request: { version, reverseFileId, absorbSampleId } }).pipe(
        mergeMap((content) =>
          absorbSampleId
            ? of(
                order.attachReverseFileSuccess({ orderId, content, absorbedSampleId: absorbSampleId }),
                /* the absorbed sample's metadata moved to the target or was unlinked server-side */
                order.getSampleMetaDatasRequest({ orderId })
              )
            : of(order.attachReverseFileSuccess({ orderId, content }))
        ),
        catchError((error: unknown) => of(order.attachReverseFileFailure({ error }), addMessage(errorMessage(describeAttachRefusal(error)))))
      )
    })
  )
